<!-- eslint-disable max-len -->
<template>
  <div class="lg:hidden absolute right-0 top-0 flex flex-col h-screen w-5/6 bg-inky-depths-800 overflow-y-auto pt-16">
    <div class="h-full border-l border-r border-inky-depths-300 border-dashed px-4 pb-4">
      <div class="h-full w-full flex justify-top flex-col border-l border-r border-b border-inky-depths-300 border-dashed">
        <MarketingNavigationMobileMenuItem v-for="(menuItem, index) in menuItems" :key="index" :menu-item="menuItem" />
        <div class="grow w-full border-b border-inky-depths-300 border-dashed"></div>
        <NuxtLink class="text-center p-4 border-b border-inky-depths-300 border-dashed underline" :to="{ name: 'login' }">Sign In</NuxtLink>
        <div class="text-center w-full p-4 border-b border-inky-depths-300 border-dashed pb-20">
          <NuxtLink class="w-full px-20 py-2 rounded-full bg-ocean-surge-700 text-nowrap" :to="{ name: 'contact' }">Book A Demo</NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MobileMenuItem } from '~/types'

const menuItems: MobileMenuItem[] = [
  {
    title: 'Home',
    routeName: 'index'
  },
  {
    title: 'Products',
    subItems: [
      { title: 'Watchkeeper', routeName: 'watchkeeper' },
      { title: 'CarbonID', routeName: 'carbonid' },
      { title: 'Connected Insurance', routeName: 'insurance' }
    ]
  },
  // {
  //   title: 'Solutions',
  //   subItems: [
  //     { title: 'For Brokers', routeName: 'for-brokers' },
  //     { title: 'For Seafarers', routeName: 'for-brokers' },
  //     { title: 'For Fleet Managers', routeName: 'for-brokers' },
  //     { title: 'For Ship Owners', routeName: 'for-brokers' }
  //   ]
  // },
  {
    title: 'About',
    routeName: 'about'
  },
  {
    title: 'News',
    routeName: 'news'
  },
  {
    title: 'We are hiring',
    routeName: 'careers'
  },
  {
    title: 'Contact',
    routeName: 'contact'
  }
]
</script>
